import { mapGetters } from "vuex";
import HomeHeader from "@/components/screens/home-screen/components/Header.vue";
import HomeMenu from "@/components/screens/home-screen/components/Menu.vue";
import HomeHero from "@/components/screens/home-screen/components/Hero.vue";
import HomeFooter from "@/components/screens/home-screen/components/Footer.vue";
import ErrorBlock from "@/components/screens/home-screen/components/ErrorBlock.vue";
import LoaderDots from "@/components/ui/layout/loader-dots/LoaderDots.vue";
import HomeNewsletter from "@/components/screens/home-screen/components/Newsletter.vue";
export default {
	name: "HomeScreen",
	components: {
		HomeHeader,
		HomeMenu,
		HomeFooter,
		ErrorBlock,
		LoaderDots,
		HomeHero,
		HomeNewsletter,
	},
	data() {
		return {
			show_language_modal: false,
		};
	},
	computed: {
		...mapGetters("processes", ["categories", "apiStatus"]),
		...mapGetters("staticContent", ["getTranslations"]),
		errorMessage() {
			return this.$store.state.processes.errorMessage;
		},
	},
	methods: {
		toggleLanguageModal() {
			this.show_language_modal = !this.show_language_modal;
		},
		toTitleCase(str) {
			return str.replace(/\w\S*/g, (txt) => {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		},
	},
	mounted() {
		this.$store.dispatch("processes/setCategories");
		this.$store.dispatch("staticContent/setStaticContent");
	},
};
